/* fiveaven : vidéos de la galerie de la fiche produit (consigne Andy 10/10/2026)
   - démarrent seules quand elles sont visibles, sans le son, en boucle ;
   - la personne peut les mettre en pause (commandes du lecteur) ; une vidéo mise en pause à la main ne redémarre pas seule. */
(function () {
  "use strict";
  function preparer(v) {
    if (v.dataset.fvAuto) return;
    v.dataset.fvAuto = "1";
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute("muted", "");
    v.setAttribute("playsinline", "");
    v.loop = true;
    v.controls = true;
    v.addEventListener("pause", function () {
      if (v.dataset.fvAutoPause) { delete v.dataset.fvAutoPause; return; } // pause automatique (vidéo sortie de l'écran)
      v.dataset.fvStop = "1"; // pause demandée par la personne : on ne relance plus tout seul
    });
    v.addEventListener("play", function () { delete v.dataset.fvStop; });
  }
  function lancer(v) {
    if (v.dataset.fvStop) return;
    // le thème pose une vignette fixe + un bouton lecture par-dessus la vidéo : on les retire pour voir la vidéo tourner
    var boite = v.closest(".external-video") || v.parentElement;
    if (boite && !boite.classList.contains("fv-video-auto")) boite.classList.add("fv-video-auto");
    if (!v.paused) return;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function arreter(v) { if (v.paused) return; v.dataset.fvAutoPause = "1"; v.pause(); }
  // 27/10/2026 : dans le carrousel, les diapos cachées sont empilées sous la diapo affichée (fondu) ; l'observateur
  // les croyait visibles et lançait toutes les vidéos au chargement (17 Mo sur mobile). On ne lance que la diapo affichée.
  // (sur ordinateur la galerie est une grille sans carrousel : ses cases gardent la classe splide__slide mais sont toutes visibles)
  function affichee(v) {
    var d = v.closest(".splide__slide");
    if (!d || !d.closest(".splide")) return true;
    return d.classList.contains("is-active") || d.classList.contains("is-visible");
  }
  function suivre(v) { if (v.dataset.fvVu && affichee(v)) lancer(v); else arreter(v); }

  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entrees) {
    // démarre dès qu'un bon morceau de la vidéo est à l'écran, s'arrête quand elle en sort
    entrees.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.15) e.target.dataset.fvVu = "1";
      else if (!e.isIntersecting) delete e.target.dataset.fvVu;
      suivre(e.target);
    });
  }, { threshold: [0, 0.15] }) : null;

  function brancher() {
    document.querySelectorAll(".product-page .product-media-container video").forEach(function (v) {
      if (v.dataset.fvAuto) return;
      preparer(v);
      if (io) io.observe(v); else if (affichee(v)) lancer(v);
    });
  }
  var attente = 0;
  function majEtat() {
    attente = 0;
    brancher();
    // changement de diapo : la vidéo qui arrive démarre, celle qui part s'arrête
    if (io) document.querySelectorAll(".product-page .product-media-container video[data-fv-auto]").forEach(suivre);
  }
  function demarrer() {
    brancher();
    // les vidéos de la galerie peuvent être insérées plus tard (média différé, changement de variante)
    var c = document.querySelector(".product-page .product-media-container");
    if (c) new MutationObserver(function () { if (!attente) attente = requestAnimationFrame(majEtat); })
      .observe(c, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer); else demarrer();
})();
